export default __webpack_public_path__ + "static/media/food-for-wellness-vegshelf.69a471b2.png";